var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import mediaQueries from 'syf-component-library/const/mediaQueries';
import { StyledFlex } from '../../../styles/common';
import { StyledText } from '../../../styles/text';
import { colors } from '../../../styles/theme';
export var StyledSubheading = styled(StyledText)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  @media ", " {\n    padding-right: 60px;\n  }\n"], ["\n  @media ", " {\n    padding-right: 60px;\n  }\n"])), mediaQueries.greaterThanMedium);
export var StyledBanner = styled(StyledFlex)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: ", ";\n\n  svg {\n    flex-shrink: 0;\n  }\n"], ["\n  background-color: ", ";\n\n  svg {\n    flex-shrink: 0;\n  }\n"])), colors.turquoiseLightest);
var templateObject_1, templateObject_2;
//# sourceMappingURL=subcomponents.js.map